module.exports = __webpack_public_path__ + "3d7bae85544db4dc5516beb009b68a07.png";